var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9878 6.70008C18.3582 2.61654 14.3881 -0.0450807 9.99392 7.75104e-05C5.629 -0.02517 1.69114 2.61885 0.0599735 6.67008C0.0215604 6.77591 0.0012875 6.88748 1.0041e-05 7.00008C-0.000518915 7.10635 0.019856 7.21168 0.0599735 7.31008C1.68479 11.3692 5.62406 14.0221 9.99392 14.0001C14.3588 14.0253 18.2967 11.3813 19.9279 7.33008C19.9706 7.22547 19.9911 7.11306 19.9878 7.00008C20.0041 6.90074 20.0041 6.79942 19.9878 6.70008ZM9.99392 12.0001C6.6124 11.9925 3.5333 10.0499 2.06875 7.00008C3.52824 3.94606 6.61076 2.00207 9.99392 2.00207C13.3771 2.00207 16.4596 3.94606 17.9191 7.00008C16.4545 10.0499 13.3754 11.9925 9.99392 12.0001ZM6.99575 7.00008C6.99575 5.34322 8.33808 4.00008 9.99392 4.00008C11.6498 4.00008 12.9921 5.34322 12.9921 7.00008C12.9921 8.65693 11.6498 10.0001 9.99392 10.0001C8.33808 10.0001 6.99575 8.65693 6.99575 7.00008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b12eb84fd010091a534d5756a7c5ee28.svg";
export { ForwardRef as ReactComponent };